import React, { memo, useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import AdminSideBar from "../shared/AdminSidebar";
import AdminHeader from "../shared/AdminHeader";
import { useSelector } from "react-redux";
import { setTitle } from "../../helpers/MetaTag";
import Button from "../../components/form/Button";
import { classNames } from "../../helpers/classNames";

const AdminLayout = ({ metaTitle }) => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const profile = useSelector((state) => state?.profile?.data);
  const settings = useSelector((state) => state?.settings?.data);
  const { session } = useSelector((state) => state?.authProvider);

  const location = useLocation();
  useEffect(() => {
    if (window.innerWidth < 1280) {
      setMenuOpen(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    setTitle(`Vpeters ${session?.user?.roleCode === "user" ? "User" : "Admin"} | ${metaTitle}`);
  }, [metaTitle, session]);

  useEffect(() => {
    if (settings?.favicon?.url) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.getElementsByTagName("head")[0].appendChild(link);
      }
      link.href = settings?.favicon?.url;
    }
  }, [settings]);

  return (
    <>
      <div className="relative flex w-full h-screen overflow-hidden [&>*]:font-CanelaDeck">
        <div>
          <div className="fixed top-4 left-4 z-[100] xls:hidden">
            {!isMenuOpen && (
              <Button
                buttonClasses={"!h-8 !w-8 !rounded-full !px-0"}
                buttonHasLink={false}
                buttonIcon={"fa-light fa-arrow-right text-sm md:text-xl"}
                buttonIconPosition={"left"}
                buttonFunction={() => setMenuOpen(true)}
              />
            )}
          </div>

          <div
            className={classNames(
              "fixed top-0 left-0 h-full w-60 bg-neutral-200 z-[80] flex flex-col transition-transform duration-300",
              isMenuOpen ? "translate-x-0" : "-translate-x-full",
              "xls:translate-x-0"
            )}
          >
            <div className="flex-shrink flex-grow">
              <AdminSideBar isMenuOpen={isMenuOpen} setMenuOpen={setMenuOpen} />
            </div>
            <div className="flex-shrink-0">
              <AdminHeader profile={profile} />
            </div>
          </div>

          <div
            className={classNames("fixed inset-0 bg-black/75 z-[70] transition-opacity duration-300 xls:hidden", isMenuOpen ? "opacity-100 visible" : "opacity-0 invisible")}
            onClick={() => setMenuOpen(false)}
          />
        </div>

        <div className={classNames("relative w-full flex flex-col transition-all duration-300", "p-0", "xls:pl-60")}>
          <div className="relative w-full h-full max-h-screen p-6 overflow-auto scroll-smooth scrollbar bg-shades-01 parent-container">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(AdminLayout);
